import { ImagesState } from './images.types';

export const preloadedImagesState: ImagesState = {
  items: {},
};
